import React, { useState, useEffect } from 'react';
import Main from '../componentes/Main';
import Axios from 'axios';
import { Grid } from "@material-ui/core";
import { Spinner, Card, Typography, Input, IconButton, Tooltip, Dialog, DialogHeader, DialogBody, DialogFooter, Button, Select, Option } from '@material-tailwind/react';
import { MagnifyingGlassIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import Swal from 'sweetalert2';
import ExportToExcelCajasRubros from '../componentes/exportExcelCajasRubros';
import { useContextoGlobal } from '../Context/contextoGlobal';
import { ListadoCelular } from '../componentes/ListadoCelular'

const ICajaModel = {
    nombre: '',
    id_rubro_ingreso: '',
    id_rubro_egreso: '',
    saldo: ''
}

export default function CajaRubros({ usuario }) {

    const [cajasRubroList, setCajasRubroList] = useState([])
    const [rubroIngresosList, setRubroIngresosList] = useState([])
    const [rubroEgresosList, setRubroEgresosList] = useState([])
    const [nameSearch, setNameSearch] = useState('')
    const [cajaId, setCajaId,] = useState(0)
    const [cajaData, setCajaData] = useState(ICajaModel);
    const [buscandoDatos, setBuscandoDatos] = useState(false)
    const [open, setOpen] = React.useState(false); 
    const [valorFormateado, setValorFormateado] = useState("");
    const { esCelular } = useContextoGlobal();

    const formatearNumero = (numero) => {
        return new Intl.NumberFormat("es-ES", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(numero);
    };

    const manejarCambio = (e) => {
        const valor = e.target.value.replace(/[,.]/g, ""); // Remueve comas y puntos para mantener solo números
        setCajaData({...cajaData, saldo: valor})
        setValorFormateado(valor); // Al editar, se muestra sin formato
    };

    const manejarBlur = () => {
        if (cajaData.saldo) {
            // Al perder el foco, muestra el valor formateado
            setValorFormateado(formatearNumero(cajaData.saldo));
        }
    };

    const manejarFocus = () => {
        // Al enfocar, elimina el formato para edición
        setValorFormateado(cajaData.saldo);
    };

    useEffect(() => {
        obtenerArchivos()
        getListRubros();
    }, [])

    const obtenerArchivos = async () => {
        setBuscandoDatos(true);
        try {
            const resultList = await Promise.all([Axios.get(`/api/tablasgenerales/cajasrubros`)])
            setCajasRubroList(resultList[0].data)
            setBuscandoDatos(false);
        } catch (error) {
            console.log(error)
            setBuscandoDatos(false);
        }
    }

    const getListRubros = async () => {
        const ingresosList = await Promise.all([Axios.get(`/api/tablasgenerales/rubrosingresos`)])
        setRubroIngresosList(ingresosList[0].data)

        const egresosList = await Promise.all([Axios.get(`/api/tablasgenerales/rubrosegresos`)])
        setRubroEgresosList(egresosList[0].data)
    }

    const handleOpen = () => setOpen(!open);

    const verCajaDeRubros = async (e) => {
        try {
            const cajaIdResponse = await Promise.all([Axios.get(`/api/tablasgenerales/cajasrubros/${e.id_caja_rubro}`)])
            const cajaSeleccionada = cajaIdResponse[0].data.recordsets[0][0];

            setValorFormateado(formatearNumero(e.saldo_inicial))
            setCajaId(cajaSeleccionada.id_caja_rubro);

            let data = {
                nombre: e.nombre,
                id_rubro_ingreso: cajaSeleccionada.id_rubro_ingreso,
                id_rubro_egreso: cajaSeleccionada.id_rubro_egreso,
                saldo: e.saldo_inicial
            }

            setCajaData(data);
            handleOpen();
        } catch (error) {
            console.log(error)
            setBuscandoDatos(false);
        }
    }

    const editarCajaDeRubros = async () => {
        try {
            await Promise.all([Axios.put(`/api/tablasgenerales/cajasrubros/${cajaId}`, cajaData)])
            Swal.fire({
                icon: 'alert',
                title: `<p>Los datos han sido actualizados con éxito</p>`,
            })
            handleOpen();
            obtenerArchivos();
        } catch (error) {
            Swal.fire({
                icon: 'alert',
                title: `<p>Error al actualizar los Datos</p>`,
                showCancelButton: true,
            })
            console.log(error)
        }
    }

    const borrarCajaDeRubros = async (e) => {
        Swal.fire({
            title: "Esta seguro que desea Eliminarlo?",
            text: "Este cambio es irreversible!",
            type: "warning",
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: "No, cancelar!",
            showCancelButton: true,
            // allowOutsideClick: false
        }).then(
            async resultado => {
                if (resultado.value) {
                    try {
                        await Promise.all([Axios.delete(`/api/tablasgenerales/cajasrubros/${e.id_caja_rubro}`)])
                        obtenerArchivos();
                    } catch (error) {
                        console.log(error)
                        setBuscandoDatos(false);
                    }
                }
            }
        )
    }

    const limpiarBusqueda = async () => {
        obtenerArchivos();
        setNameSearch('')
    }

    const handleSearchData = async () => {
        if (nameSearch.trim() === '') {
            setCajasRubroList(cajasRubroList);
        } else {
            const listaFiltrada = cajasRubroList.filter(item =>
                item.nombre.toLowerCase().includes(nameSearch.toLowerCase())
            );
            setCajasRubroList(listaFiltrada.length > 0 ? listaFiltrada : cajasRubroList);
        }
    }

    const verCrearCajaRubro = async () => {
        try {
            setCajaId(0);
            setValorFormateado('')
            handleOpen();
            setCajaData(ICajaModel)
        } catch (error) {
            console.log(error)
            setBuscandoDatos(false);
        }
    }

    const crearCajaRubro = async () => {
        try {
            await Promise.all([Axios.post(`/api/tablasgenerales/cajasrubros/`, cajaData)])
            Swal.fire({
                icon: 'alert',
                title: `<p>La Caja Rubro ha sido creado con éxito</p>`,
            })
            handleOpen();
            obtenerArchivos();
        } catch (error) {
            Swal.fire({
                icon: 'alert',
                title: `<p>Error al crear los Datos</p>`,
                showCancelButton: true,
            })
            console.log(error)
            setOpen(true);
        }
    }

    if (buscandoDatos) {
        return <Main center alinear>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <Spinner className="h-12 w-12" />
                <span className="cargando font-semibold text-[15px]">Cargando archivos...</span>
            </div>
        </Main>
    }

    if (cajasRubroList.length == 0) {
        return <Grid container justifyContent='center' alignItems='center' style={{ minHeight: '400px', textAlign: 'center' }} >
            <Grid item>
                <Typography variant="h5">
                    No se encontraron archivos
                </Typography>
            </Grid>
        </Grid>
    }

    return <div className='w-full flex flex-col justify-center items-center lg:!m-6 xl:!m-6'>
        <Typography variant="h4" className="flex ">
            Fondos en Tránsito
        </Typography>
        <Card className='w-full justify-center items-center flex p-5 justify-left mt-4'>
            <div className='w-full lg:w-96 xl:w-96 relative'>
                <Input
                    type="text"
                    label="Buscar nombre de Caja"
                    value={nameSearch}
                    onChange={(e) => { setNameSearch(e.target.value) }}
                    color='black'
                />
                <Button
                    size="sm"
                    color={nameSearch ? "blue" : "blue-gray"}
                    disabled={!nameSearch}
                    className="!absolute right-1 top-1 rounded flex"
                    onClick={handleSearchData}
                >
                    <MagnifyingGlassIcon className="h-4 w-4 mr-2" />Buscar
                </Button>
            </div>
            {cajasRubroList.length > 0 && <div className='mt-8 w-full'>
                <div className="flex flex-col md:flex-row gap-2 xl:!justify-end">
                    <Button className="flex md:ml-2 justify-center gap-3 bg-green-500" onClick={verCrearCajaRubro}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="h-4 w-4"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 4.5v15m7.5-7.5h-15"
                            />
                        </svg>
                        Crear
                    </Button>
                    <Button variant='text' className='text-red-400 bg-red-100 hover:bg-red-200' onClick={limpiarBusqueda}>Limpiar Busqueda</Button>
                    <ExportToExcelCajasRubros data={cajasRubroList} fileName="Listado de Fondos en tránsito"/>
                </div>
                <Typography
                    variant="small"
                    color="blue-gray"
                    className="font-normal leading-none hidden lg:flex"
                >
                    Se han encontrado {cajasRubroList.length} FETs
                </Typography>
                {esCelular ? 
                    <ListadoCelular datos={cajasRubroList} verSeleccionado={verCajaDeRubros} borrar={borrarCajaDeRubros} />
                        :
                    <table className="w-full min-w-max table-auto text-left mt-2">
                        <thead>
                            <tr>
                                <th
                                    className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                                >
                                    <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal leading-none opacity-70"
                                    >
                                        Nombre
                                    </Typography>
                                </th>
                                <th
                                    className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                                >
                                    <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal leading-none opacity-70"
                                    >
                                        Cuenta de Ingreso
                                    </Typography>
                                </th>
                                <th
                                    className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                                >
                                    <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal leading-none opacity-70"
                                    >
                                        Cuenta de Egreso
                                    </Typography>
                                </th>
                                <th
                                    className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                                >
                                    <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal leading-none opacity-70"
                                    >
                                        Saldo
                                    </Typography>
                                </th>
                                <th
                                    className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                                >
                                    <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal leading-none opacity-70"
                                    >
                                        Acciones
                                    </Typography>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {cajasRubroList.map((item, index) => {
                                const isLast = index === cajasRubroList.length - 1;
                                const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

                                return (
                                    <tr key={index}>
                                        <td className={classes}>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-normal"
                                            >
                                                {item.nombre}
                                            </Typography>
                                        </td>
                                        <td className={classes}>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-normal"
                                            >
                                                {item.rubro_ingreso}
                                            </Typography>
                                        </td>
                                        <td className={classes}>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-normal"
                                            >
                                                {item.rubro_egreso}
                                            </Typography>
                                        </td>
                                        <td className={`${classes} text-right`}>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-normal"
                                            >
                                                {item.saldo_inicial.toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </Typography>
                                        </td>
                                        <td className={classes}>
                                            <div className="flex items-center gap-2">
                                                <Tooltip content="Ver Detalles">
                                                    <IconButton variant="text" size="sm" onClick={() => verCajaDeRubros(item)}>
                                                        <PencilIcon className="h-4 w-4 text-gray-900" />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip content="Eliminar">
                                                    <IconButton variant="text" size="sm" onClick={() => borrarCajaDeRubros(item)}>
                                                        <TrashIcon className="h-4 w-4 text-gray-900" />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table> 
                }


            </div>}
        </Card>
        <Dialog open={open} handler={handleOpen}>
            <DialogHeader>Unión de las Asambleas de Dios</DialogHeader>
            <DialogBody className="xl:p-10">

                <div className="flex flex-col w-full mt-4">
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="mb-1 font-medium "
                    >
                        Nombre
                    </Typography>
                    <Input
                        onChange={(e) => {
                                        setCajaData({...cajaData, nombre: e.target.value})
                                    }}
                        value={cajaData.nombre}
                        type='text'
                        id='name'
                        name='name'
                        color='black'
                        className="!border-t-blue-gray-200 focus:!border-t-gray-900"
                        labelProps={{
                            className: "before:content-none after:content-none",
                        }}
                    />
                </div>

                <div className="flex flex-col w-full mt-4 select-ui-data">
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="mb-1 font-medium "
                    >
                        Cuenta de Ingresos
                    </Typography>
                    <Select
                        label="Seleccione un ingreso"
                        onChange={(e) => {
                                        setCajaData({...cajaData, id_rubro_ingreso: e})
                                    }}
                        value={cajaData.id_rubro_ingreso}
                        className=""
                    >
                        {rubroIngresosList.map((item, index) => (
                            <Option key={item.id_rubro_ingreso} value={item.id_rubro_ingreso}>
                                {item.nombre}
                            </Option>
                        ))}
                    </Select>
                </div>

                <div className="flex flex-col w-full mt-4 select-ui-data">
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="mb-1 font-medium "
                    >
                        Cuenta de Egresos
                    </Typography>
                    <Select
                        label="Seleccione un egreso"
                        onChange={(e) => {
                                        setCajaData({...cajaData, id_rubro_egreso: e})
                                    }}
                        value={cajaData.id_rubro_egreso}
                        className=""
                    >
                        {rubroEgresosList.map((item, index) => (
                            <Option key={item.id_rubro_egreso} value={item.id_rubro_egreso}>
                                {item.nombre}
                            </Option>
                        ))}
                    </Select>
                </div>

                <div className="flex flex-col w-full mt-4">
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="mb-1 font-medium "
                    >
                        Saldo inicial
                    </Typography>
                    
                    <Input
                        onChange={manejarCambio}
                        onBlur={manejarBlur}
                        onFocus={manejarFocus}
                        value={valorFormateado}
                        type="text" // Usar tipo "text" para mostrar con comas y puntos
                        id="name"
                        name="name"
                        color="black"
                        className="!border-t-blue-gray-200 focus:!border-t-gray-900"
                        labelProps={{
                            className: "before:content-none after:content-none",
                        }}
                    />
                </div>
            </DialogBody>
            <DialogFooter className="space-x-2">
                <Button 
                    variant="gradient" 
                    color="blue" 
                    onClick={() => cajaId !== 0 ? editarCajaDeRubros() : crearCajaRubro()}
                    >
                        Guardar
                </Button>
                <Button variant="text" color="blue-gray" onClick={handleOpen}>
                    Cancelar
                </Button>
            </DialogFooter>
        </Dialog>
    </div>
}

